import { __assign } from "tslib";
import { StyleSheet } from "react-native";
var textStyle = {
  fontSize: 16,
  lineHeight: 20,
  marginTop: 5,
  marginBottom: 5,
  marginLeft: 10,
  marginRight: 10
};
export default {
  left: StyleSheet.create({
    container: {},
    text: __assign({
      color: "black"
    }, textStyle),
    link: {
      color: "black",
      textDecorationLine: "underline"
    }
  }),
  right: StyleSheet.create({
    container: {},
    text: __assign({
      color: "white"
    }, textStyle),
    link: {
      color: "white",
      textDecorationLine: "underline"
    }
  })
};